import React from 'react'

import SharedTemplatesBlock from "./templates-library/templates-library"
import TemplatesListLibrary from './templates-list/templates-list-library'

import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {templatesLibrary} from "../../config/library"
import NewTitleBreadcrumb from "../../../../layout/page-title/form-title-breadcrumb"
import {BreadcrumbCustomItem} from "../../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddItemBreadcrumb} from "../../../../@types"

type Props = {
    onSelect    : {(type: any, templateId: ID): void}
}

type State = {
    currentCategory?: ID
}

export default class NewSelector extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            currentCategory: undefined
        }
    }

    onCategorySelect = (categoryId: ID) => {
        this.setState({currentCategory: categoryId});
    }

    onSelectType = (type: any, id: ID) => {
        this.props.onSelect(type, id);
    }

    render() {
        const selectedCategory = this.state.currentCategory ? this.state.currentCategory : templatesLibrary[0].id

        const breadcrumbItems: BreadcrumbCustomItem[] = [
            QuickAddItemBreadcrumb.PROJECT_RESOURCES,
            QuickAddItemBreadcrumb.PROJECT_TEMPLATE_LIBRARY,
        ]

        return (
            <div className="new-form-layout">
                <NewTitleBreadcrumb breadcrumbItems={breadcrumbItems}/>

                <VScroll className="quick-add-content m-t-35">
                    <div className="select-template-content">
                        <div className="left-content">
                            <SharedTemplatesBlock selectedCategory  = {selectedCategory}
                                                  onCategorySelect  = {this.onCategorySelect}/>
                        </div>
                        <div className="right-content">
                            <TemplatesListLibrary categoryId    = {selectedCategory}
                                                  onSelect      = {this.onSelectType}/>
                        </div>
                    </div>
                </VScroll>
            </div>
        )
    }
}